import { Transaction } from 'interfaces/moneyflow'
import { FC } from 'react'
import styles from 'components/features/creditCard/creditCardPage/RecentTransactionItem/RecentTransactionItem.styl'
import { formatUSCurrency } from 'helpers/formatHelpers'
import cn from 'classnames'
import TooltipIcon from 'components/features/pfm/Tooltip/TooltipIcon'
import { TransactionDetailsPaneButton } from 'components/features/pfm/Button/FloatingPaneButtons'
import Flex from 'components/atoms/Flex/Flex'
import { TransactionCategory } from 'components/features/pfm/TransactionCategory/TransactionCategory'

type RecentTransactionItemProps = {
  transaction: Transaction
  className?: string
}

export const RecentTransactionItem: FC<RecentTransactionItemProps> = (props) => {
  const { className, transaction } = props
  const { uid, description, amount, category, status } = transaction
  const isPending = status === 'pending'

  return (
    <TransactionDetailsPaneButton uid={ uid } className={ cn(styles.transaction, className) } component='div' fullWidth={ false }>
      <Flex horizontal gap='spread'>
        <div className={ styles.title }>
          { description }
          { transaction.account_source_type === 'yodlee' && transaction.description && transaction.description_verbose && (
            <div className={ styles.tooltip }>
              <TooltipIcon icon='ellipsis'>{ transaction.description_verbose }</TooltipIcon>
            </div>
          )}
        </div>
        <div className={ cn(styles.amount, { [styles.green]: amount < 0 }) }>
          { formatUSCurrency(amount, 'penny') }
        </div>
      </Flex>
      <Flex horizontal gap='spread'>
        <div className={ styles.category }>
          <TransactionCategory
            category={ category }
            dim={ isPending }
            slim
            disabled
          />
        </div>
        <small className={ styles.seeMore }>
          <TransactionDetailsPaneButton text='See Details' uid={ uid } renderAsLink />
        </small>
      </Flex>
    </TransactionDetailsPaneButton>
  )
}
